import { render, staticRenderFns } from "./edit-giftsetsalert-popup.vue?vue&type=template&id=64323aa0"
import script from "./edit-giftsetsalert-popup.vue?vue&type=script&lang=js"
export * from "./edit-giftsetsalert-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports